import { useBapi } from "@/bapi-client";
import { BAPI_COMMANDS } from "@/bapi-client/types/commands";
import { TermsAndConditions } from "@/bapi-client/types/terms-and-conditions";
import useNotificationStore from "@/stores/notifications";
import { useUserStore } from "@/stores/user";

export function useTermsAndConditions() {
  const notifier = useNotificationStore();
  const userStore = useUserStore();

  async function getLatestTermsAndConditions(customerId: string): Promise<TermsAndConditions | undefined> {
    const response = await useBapi(BAPI_COMMANDS.TERMS_AND_CONDITIONS_GET_LATEST_TERMS_AND_CONDITIONS, customerId);

    if (!response.success) {
      notifier.setToast("danger", "Unable to get latest Terms and Conditions");
      return;
    }

    return response.data.terms_and_conditions;
  }

  async function getAllAcceptedTermsAndConditions(customerId: string): Promise<TermsAndConditions[] | undefined> {
    const response = await useBapi(
      BAPI_COMMANDS.TERMS_AND_CONDITIONS_GET_ALL_ACCEPTED_TERMS_AND_CONDITIONS,
      customerId,
    );

    if (!response.success) {
      notifier.setToast("danger", "Unable to get latest Terms and Conditions");
      return;
    }

    return response.data.terms_and_conditions;
  }

  async function acceptTermsAndConditions(termsAndConditionsId: string, callbackFn?: () => void): Promise<void> {
    const response = await useBapi(
      BAPI_COMMANDS.TERMS_AND_CONDITIONS_ACCEPT_TERMS_AND_CONDITIONS,
      termsAndConditionsId,
    );

    if (!response.success) {
      notifier.setToast("danger", "Unable to accept Terms and Conditions");
      return;
    }

    if (response.success && callbackFn) {
      callbackFn();
    }

    return;
  }

  async function isLatestTermsAndConditionsAccepted(): Promise<[boolean, TermsAndConditions | undefined]> {
    const latestTermsAndConditions = await getLatestTermsAndConditions(userStore.customerId);
    const allAcceptedTermsAndConditions = await getAllAcceptedTermsAndConditions(userStore.customerId);

    // Check if latest terms id is found in array of accepted terms
    const isAccepted = allAcceptedTermsAndConditions?.some((t) => t.id === latestTermsAndConditions?.id) ? true : false;

    return [isAccepted, latestTermsAndConditions];
  }

  return { isLatestTermsAndConditionsAccepted, acceptTermsAndConditions };
}
